/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CsvImport from './csv-import-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CsvImport {...validProps} />;
}
SvgComponent.iconName = 'csvImport';

export const CsvImportIcon = svgIconWrapper(SvgComponent);
